import { isMobile, isMobileSimple, isTelephone, isEmail, isQQ, trimVal, isIdCard } from './validate';


/**
 * 校验 不小于
 *
 * @export
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateMin(rule, value, callback) {
  if (!rule.min) {
    console.warn(`validateMin ${rule.field} miss min cinfig in rule`);
    return;
  }

  if (trimVal(value).length < rule.min) {
    callback(new Error(rule.message || `不能小于${rule.min}位数`));
  } else {
    callback();
  }
}


/**
 * 校验 不大于
 *
 * @export
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateMax(rule, value, callback) {
  if (!rule.min) {
    console.warn(`validateMax ${rule.field} miss max cinfig in rule`);
    return;
  }

  if (trimVal(value).length < rule.min) {
    callback(new Error(rule.message || `不能大于${rule.min}位数`));
  } else {
    callback();
  }
}


/**
 * 校验 手机号码
 *
 * @export
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateMobile(rule, value, callback) {
  if (!isMobile(trimVal(value))) {
    callback(new Error(rule.message || '手机号码格式不正确'));
  } else {
    callback();
  }
}

/**
 * 校验 手机号码
 *
 * 规则：只做长度的校验
 *
 * @export
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateMobileSimple(rule, value, callback) {
  if (!isMobileSimple(trimVal(value))) {
    callback(new Error(rule.message || '手机号码格式不正确'));
  } else {
    callback();
  }
}


/**
 * 校验 固定电话 & 手机号码
 *
 * @export
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateTelephoneAndMobile(rule, value, callback) {
  if (isMobileSimple(trimVal(value)) || isTelephone(trimVal(value))) {
    callback();
  } else {
    callback(new Error(rule.message || '电话号码格式不正确'));
  }
}


/**
 * 校验 邮箱
 *
 * @export
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateEmail(rule, value, callback) {
  if (!isEmail(trimVal(value))) {
    callback(new Error(rule.message || '邮箱格式不正确'));
  } else {
    callback();
  }
}


/**
 * 校验 QQ
 *
 * @export
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateQQ(rule, value, callback) {
  if (!isQQ(trimVal(value))) {
    callback(new Error(rule.message || 'QQ号码格式不正确'));
  } else {
    callback();
  }
}

/**
 * 校验身份证
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateIdCard(rule, value, callback) {
  if (!isIdCard(trimVal(value))) {
    callback(new Error(rule.message || '身份证号格式不正确'));
  } else {
    callback();
  }
}

/**
 * 校验密码
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validatePassword(rule, value, callback) {
  if (!String((trimVal(value)).match(/^\d{6}$/) || (trimVal(value).length > 6))) {
    callback(new Error(rule.message));
  } else {
    callback();
  }
}

/**
 * 校验 密码
 *
 * @export
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validatePwd(rule, value, callback) {
  const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,20}$/;
  if (!reg.test(value)) {
    callback(new Error('至少包括大写字母、小写字母、数字、特殊字段中的3种字符'));
  } else {
    callback();
  }
}
